import React from 'react'
import DocumentTitle from 'react-document-title'
import Spinner from 'react-spinkit'
import { FavoritesBox, ActionsWidget, ToggleWidget } from '../components'
import favorites from '../http/favorites'

export default class FavoritesPage extends React.Component {
  constructor (props){
    super(props)

    this.state = {
      loading: false,
      favoritesList: [],
    }
  }

  componentDidMount() {
    this.fetch()
  }

  editFavorite(data, cb) {
    let username = localStorage.getItem('username')
    favorites.edit(username, data, (status) => {
      if (status) {
        cb(status)
        this.fetch()
      }
    })
  }

  deleteFavorite(id, cb) {
    let username = localStorage.getItem('username')
    favorites.delete(username, id, (status) => {
      cb(status)
    })
  }

  toggleAuto(id, cb) {
    let username = localStorage.getItem('username')
    favorites.toggle(username, id, (status) => {
      cb(status)
    })
  }

  showFavorites(results) {
    this.setState({
      favoritesList: results,
      loading: false,
    })
  }

  compare(a,b) {
    if (a.query < b.query)
	  return -1;
    if (a.query > b.query)
	  return 1;
    return 0;
  }

  fetch() {
    this.setState({
      loading: true,
    })
    favorites.fetch((results) => {
      let cleanedResults = results.map((result) => ({
        id: result.id,
        categoryId: result.item.category,
        category: result.item.category,
        tags: result.item.tags,
        query: result.item.query,
        toggle: <ToggleWidget key={'toggle-' + result.id} toggleAuto={this.toggleAuto.bind(this)} id={result.id} status={result.item.trigger} />,
        delete: <ActionsWidget key={'actions-' + result.id} deleteFavorite={this.deleteFavorite.bind(this)} refreshParent={this.fetch.bind(this)} id={result.id} />,
      }))
	  cleanedResults.sort(this.compare)
      this.showFavorites(cleanedResults)
    })
  }

  render() {
    return (
      <DocumentTitle title={'Café App'}>
      <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3>Favoris {this.state.loading ? <Spinner spinnerName="three-bounce" className="col-xs-1 pull-right" noFadeIn /> : ''}</h3>
              <hr />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <FavoritesBox editFavorite={this.editFavorite.bind(this)} favoritesList={this.state.favoritesList} />
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/FavoritesPage.js